/** Форматирование чисел и единиц для админ-интерфейса. */

/** Преобразует миллисекунды в человекочитаемое «Xс» или «Xм Yс». */
export function formatMs(ms: number): string {
  if (ms <= 0) return "0с";
  const totalSec = Math.round(ms / 1000);
  if (totalSec < 60) return `${totalSec}с`;
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  if (s === 0) return `${m}м`;
  return `${m}м ${s}с`;
}

/** Возвращает правильное окончание: 1 «клик», 2-4 «клика», 5+ «кликов». */
export function pluralRu(
  n: number,
  one: string,
  few: string,
  many: string,
): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}
